import { render, staticRenderFns } from "./VendorType.vue?vue&type=template&id=4e1d58ff&"
import script from "./VendorType.vue?vue&type=script&lang=js&"
export * from "./VendorType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports